/* ==========================================================================
   COMIC LEGION custom scripts (loaded with defer from snippets/cl-head-styles).
     1. Product grid lines: marks the products on the right / bottom edge of each grid (cl-edge-r / cl-edge-b)
        so the grey lines only show between products (styles in cl-custom.css)
     2. Publisher / FOC Date filter dropdowns
     3. Reviews carousel arrows
   ========================================================================== */

/* 1. Product grid lines */
(function () {
  function mark() {
    document.querySelectorAll('.product-list').forEach(function (list) {
      var items = Array.prototype.filter.call(list.querySelectorAll('.product-item'), function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var firstTop = items[0].offsetTop, cols = 0;
      while (cols < items.length && Math.abs(items[cols].offsetTop - firstTop) < 2) cols++;
      items.forEach(function (el, i) {
        el.classList.toggle('cl-edge-r', (i % cols) === cols - 1 || i === items.length - 1);
        el.classList.toggle('cl-edge-b', i + cols >= items.length);
      });
    });
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(mark, 60); }
  document.addEventListener('DOMContentLoaded', mark);
  window.addEventListener('load', mark);
  window.addEventListener('resize', later);
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].addedNodes.length && !(records[i].target.closest && records[i].target.closest('.product-item'))) { later(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* 2. */
/* Publisher / FOC Date dropdowns (snippets/cl-filter-select): choosing "All publishers" / "All FOC dates" reloads the
   products without that filter, using the theme's own clear-filters action. Other choices go through the theme as usual. */
document.addEventListener('change', function (event) {
  var el = event.target;
  if (!el || !el.matches || !el.matches('[data-cl-filter-select]') || el.value) return;
  event.stopPropagation();
  var url = new URL(window.location.href);
  url.searchParams.delete(el.name);
  url.searchParams.delete('page');
  var button = document.createElement('button');
  button.type = 'button';
  button.hidden = true;
  button.setAttribute('data-action', 'clear-filters');
  button.setAttribute('data-url', url.pathname + url.search);
  el.closest('form').appendChild(button);
  button.click();
  button.remove();
}, true);

/* 3. */
/* Reviews carousel (sections/cl-reviews): arrows scroll one screen of cards; each arrow hides at its end. Phones and tablets swipe. */
function clInitReviews(root) {
  if (!root || root.dataset.clReady) return;
  var track = root.querySelector('[data-cl-reviews-track]');
  var prev = root.querySelector('[data-cl-reviews-prev]');
  var next = root.querySelector('[data-cl-reviews-next]');
  if (!track || !prev || !next) return;
  root.dataset.clReady = '1';
  function cardWidth() {
    var card = track.querySelector('.cl-review');
    return card ? card.getBoundingClientRect().width : track.clientWidth;
  }
  function step() {
    var w = cardWidth();
    return w * Math.max(1, Math.round(track.clientWidth / w));
  }
  function update() {
    var max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
  }
  prev.addEventListener('click', function () {
    if (track.scrollLeft <= 2) return;
    track.scrollBy({ left: -step(), behavior: 'smooth' });
  });
  next.addEventListener('click', function () {
    track.scrollBy({ left: step(), behavior: 'smooth' });
  });
  track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
  window.addEventListener('resize', update);
  update();
}
document.querySelectorAll('[data-section-type="cl-reviews"]').forEach(clInitReviews);
/* Theme editor: a re-rendered or newly added reviews section gets set up too */
document.addEventListener('shopify:section:load', function (event) {
  clInitReviews(event.target.querySelector('[data-section-type="cl-reviews"]'));
});
